import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { observer } from 'mobx-react';
import { Preferences } from 'src/marketing/components/preferences/preferences';
import { Headline } from '@servicetitan/design-system';

@observer
export class OptOutPageContainer extends React.Component<
    RouteComponentProps<{ emailId: string; version?: string }>
> {
    private get emailId(): string {
        return this.props.match.params.emailId;
    }

    private get version(): string | undefined {
        return this.props.match.params.version;
    }

    render() {
        return (
            <Preferences
                header={<Headline bold>Update Email Preferences</Headline>}
                emailId={this.emailId}
                version={this.version}
                showUnsubscribeButton
            />
        );
    }
}
